import { useState, useEffect } from 'react';

const getMode = () => ({
  mobile: window.matchMedia('(max-width: 768px)').matches,
  reducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
  coarsePointer: window.matchMedia('(pointer: coarse)').matches,
});

export function usePerfMode() {
  const [mode, setMode] = useState(getMode);

  useEffect(() => {
    const queries = [
      window.matchMedia('(max-width: 768px)'),
      window.matchMedia('(prefers-reduced-motion: reduce)'),
      window.matchMedia('(pointer: coarse)'),
    ];
    const onChange = () => setMode(getMode());
    queries.forEach((mq) => mq.addEventListener('change', onChange));
    return () => queries.forEach((mq) => mq.removeEventListener('change', onChange));
  }, []);

  const lite = mode.mobile || mode.reducedMotion;
  return { ...mode, lite };
}
